import Overlay from 'praece-react-bootstrap/lib/Overlay';
import Popover from 'praece-react-bootstrap/lib/Popover';
import React from 'react';
import PropTypes from 'prop-types';

import { isMobile } from 'constants';
import { stopPropagation, preventDefault } from 'utils/event-handlers';
import SVG from 'components/widgets/icons/svg';


export default class UrgencyPicker extends React.Component {
  static propTypes = {
    setUrgency: PropTypes.func.isRequired,
    children: PropTypes.node
  };

  constructor() {
    super();

    this.state = { showPopover: false };

    this.handleClick = this.handleClick.bind(this);
    this.adjustPosition = this.adjustPosition.bind(this);
    this.show = () => this.setState({ showPopover: true });
    this.hide = () => this.setState({ showPopover: false });
  }

  handleClick(value) {
    this.hide();
    this.props.setUrgency(value);
  }

  adjustPosition(overlay) {
    // Don't adjust the position on mobile
    if (isMobile) return;

    setTimeout(() => {
      const arrow = overlay.querySelector('.arrow');
      const left = overlay.getBoundingClientRect().left; // eslint-disable-line no-undef
      const offset = left < 109 ? left : 109;

      overlay.style.marginLeft = `${offset}px`;
      arrow.style.marginLeft = `-${offset - 5}px`;
    }, 0);
  }

  render() {
    const { children } = this.props;
    const { showPopover } = this.state;

    const header = (
      <div className="w-100 d-flex">
        <span className="p-1">Set Urgency</span>
        <SVG onClick={this.hide} className="close" src="svg/close.svg" />
      </div>
    );

    return (
      <div onClick={stopPropagation()}>
        <div onClick={stopPropagation(preventDefault(this.show))}>{children}</div>
        <Overlay
          rootClose
          show={showPopover}
          placement="bottom"
          target={this}
          onEntering={this.adjustPosition}
          onHide={this.hide}
        >
          <Popover
            id="urgency-window"
            title={header}
            onClick={stopPropagation()}
            onMouseOver={stopPropagation()}
          >
            <ul>
              <li className="urgency-critical">
                <span className="urgency-pill-wrapper">
                  <span className="urgency-pill" onClick={() => this.handleClick('Critical')}>Critical</span>
                </span>
                <span className="urgency-description">
                  <span className="urgency-description-arrow"></span>
                  Review / complete IMMEDIATELY in the morning
                </span>
              </li>
              <li className="urgency-urgent">
                <span className="urgency-pill-wrapper">
                  <span className="urgency-pill" onClick={() => this.handleClick('Urgent')}>Urgent</span>
                </span>
                <span className="urgency-description">
                  <span className="urgency-description-arrow"></span>
                  Prioritize during daily work
                </span>
              </li>
              <li className="urgency-planned">
                <span className="urgency-pill-wrapper">
                  <span className="urgency-pill" onClick={() => this.handleClick('Planned')}>Planned</span>
                </span>
                <span className="urgency-description">
                  <span className="urgency-description-arrow"></span>
                  Complete on a hard timeline (meetings, calls, etc.)
                </span>
              </li>
              <li className="urgency-normal">
                <span className="urgency-pill-wrapper">
                  <span className="urgency-pill" onClick={() => this.handleClick('Normal')}>Normal</span>
                </span>
              </li>
              <li className="urgency-pending-input">
                <span className="urgency-pill-wrapper">
                  <span className="urgency-pill" onClick={() => this.handleClick('Pending Input')}>Pending Input</span>
                </span>
                <span className="urgency-description">
                  <span className="urgency-description-arrow"></span>
                  Requires more information, ping on Due Date
                </span>
              </li>
              <li className="urgency-after-hours">
                <span className="urgency-pill-wrapper">
                  <span className="urgency-pill" onClick={() => this.handleClick('After Hours')}>After Hours</span>
                </span>
                <span className="urgency-description">
                  <span className="urgency-description-arrow"></span>
                  Complete after business hours
                </span>
              </li>
            </ul>
          </Popover>
        </Overlay>
      </div>
    );
  }
}
